import Vue from 'vue';
import Router from "vue-router";
import Home from '../pages/home'
import Login from '../pages/login'
import Learn from '../pages/learn'
import Train from '../pages/train-page'

Vue.use(Router);
const VueRouterPush = Router.prototype.push 
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '',
      name: '首页',
      component: Home
    },
    {
      path: '/login',
      name: '登录',
      component: Login
    },
    {
      path: '/learn',
      name: '学习',
      component: Learn
    },
    {
      path: '/train',
      name: '练习',
      component: Train
    },
    {
      path: '**/**',
      redirect: '/'
    }
  ]
})